import ComposeTab from './ComposeTab/ComposeTab';
import HistoryTab from './HistoryTab/HistoryTab';
import ReEngagementTab from './ReEngagementTab/ReEngagementTab';
import ReEngagementHistoryTab from './ReEngagementHistoryTab/ReEngagementHistoryTab';
import texts from './texts.json';

const tabs = {
  COMPOSE: 'COMPOSE',
  HISTORY: 'HISTORY',
  REENGAGEMENT: 'REENGAGEMENT',
  REENGAGEMENT_HISTORY: 'REENGAGEMENT_HISTORY',
};

const tabsConfig = {
  [tabs.COMPOSE]: {
    label: texts.tabLabels[tabs.COMPOSE],
    component: ComposeTab,
  },
  [tabs.HISTORY]: {
    label: texts.tabLabels[tabs.HISTORY],
    component: HistoryTab,
  },
  [tabs.REENGAGEMENT]: {
    label: texts.tabLabels[tabs.REENGAGEMENT],
    component: ReEngagementTab,
  },
  [tabs.REENGAGEMENT_HISTORY]: {
    label: texts.tabLabels[tabs.REENGAGEMENT_HISTORY],
    component: ReEngagementHistoryTab,
  },
};

export {
  tabs,
  tabsConfig,
};
